export const LOADING_MEDIAS = "LOADING_MEDIAS";
export const SUCCESS_GET_MEDIAS = "SUCCESS_GET_MEDIAS";
export const SET_ERROR_MEDIAS = "SET_ERROR_MEDIAS";
export const LOADING_DOCUMENTS = "LOADING_DOCUMENTS";
export const SUCCESS_GET_DOCUMENTS = "SUCCESS_GET_DOCUMENTS";
export const SET_ERROR_DOCUMENTS = "SET_ERROR_DOCUMENTS";
export const LOADING_PHOTOS = "LOADING_PHOTOS";
export const SUCCESS_GET_PHOTOS = "SUCCESS_GET_PHOTOS";
export const SET_ERROR_PHOTOS = "SET_ERROR_PHOTOS";
export const RESET = "RESET";